'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateUIFormControlValidationMessage;

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// #4597
function validateUIFormControlValidationMessage(props) {
  var validationMessage = props.validationMessage,
      error = props.error;


  if (validationMessage && !error) {
    _devLogger2.default.warn({
      message: 'UIFormControl: Use of `error={false}` with `validationMessage` is discouraged.',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/4597',
      key: 'UIFormControl: `error={false}` with `validationMessage`'
    });
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/form/utils/validateUIFormControlValidationMessage.js
// module id = 586
// module chunks = 177